// extracted by mini-css-extract-plugin
export default {"container":"PersonalItemsAlert-module__container--IkFgU"};